import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Row, Card, CardBody } from "reactstrap";
import Layout from "../../ui/layout";
import Breadcrumb from "../../ui/breadcrumb";
import ErrorPage from "../../ui/error";
import errorRed from "../../../assets/img/error-red.png";
import "./css/index.scss";
import Users from "./users";
import Files from "./files";
import { usePageView } from "../../../utils/google-analytics-handler";


const AdministrationPanel = () => {
  usePageView();
  const { error, current } = useSelector(state => state.user);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const pages = [
    { name: "Conciliaciones", path: "/", active: false },
    { name: "Administración", path: "/admin", active: true }
  ];
  if (error)
    return (
      <ErrorPage
        title="Ha habido un error"
        subtitle="Oopps. Ha habido gestionando usuarios"
        text="Recargue la página y si el error persiste contacte con el CSU"
        image={errorRed}
        email={current.email}
        role={current.role}
        pages={pages}
      />
    );
  const options = [
    { name: "Usuarios", icon: "icono-person" },
    { name: "Ficheros", icon: "icono-doc-xls" }
  ];
  return (
    <Layout email={current.email} role={current.role} pages={pages}>
      <Breadcrumb
        elements={[
          { name: "CPA", active: false },
          { name: "Administración", active: true, action: () => {} }
        ]}
      />
      <h2>Panel de Administración</h2>
      <Row>
        <div className="col-3">
          <Card className="mt-sm-3">
            <CardBody className="pt-2 col admin-menu">
              {options.map((x, i) => {
                let selectedClass = "option";
                selectedClass += i === selectedIndex ? " selected" : "";
                return (
                  <button
                    onClick={() => setSelectedIndex(i)}
                    type="button"
                    className={selectedClass}
                  >
                    <i className={x.icon} />
                    <span className="text">{x.name}</span>
                  </button>
                );
              })}
            </CardBody>
          </Card>
        </div>
        <div className="col-9">{!selectedIndex ? <Users /> : <Files />}</div>
      </Row>
    </Layout>
  );
};

export default AdministrationPanel;
